const LandlordProgressbar = ({ step = 1 }) => {
  const progress = Math.min(step * 20, 100); // 1 → 20%, 5 → 100%

  return (
    <div
      className="progress landlord-progressbar"
      role="progressbar"
      aria-label="Landlord progress"
      aria-valuenow={progress}
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div className="progress-bar" style={{ width: `${progress}%` }}></div>
    </div>
  );
};

export default LandlordProgressbar;
